export type SelectValue = string | { label?: string; value: any; [key: string]: unknown };

export function isString(value: any): value is string {
  return typeof value === 'string';
}

export type CommonPositionOptions = 'auto' | 'bottom' | 'bottom-end' | 'bottom-start' | 'top-start' | 'top' | 'top-end' | 'left' | 'right';
export type CommonSizes = 'lg' | 'md' | 'sm';
export type CommonMessageTypes = 'error' | 'warning' | undefined;
export type CommonPositionOptionsV2 = 'auto' | 'bottom-start' | 'top-start' | 'bottom-end' | 'top-end';
export type CommonTargetTypes = '_self' | '_blank' | '_parent' | '_top' | undefined;
export type CommonHeadingTypes = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
